export const checkInfluencerCode = () => {
  // Check for influencer code in params and save it in localStorage with a expires in 30 days
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('influencerCode')) {
    const influencerCode = urlParams.get('influencerCode');
    localStorage.setItem('influencerCode', influencerCode);
    // Set expiration date for 30 days
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);
    localStorage.setItem('influencerCodeExpiration', expirationDate.toISOString());
  } else {
    // check if influencer code is already stored and not expired
    const storedCode = localStorage.getItem('influencerCode');
    const expirationDate = localStorage.getItem('influencerCodeExpiration');
    if (storedCode && expirationDate) {
      const now = new Date();
      if (new Date(expirationDate) < now) {
        // Code expired, remove it
        localStorage.removeItem('influencerCode');
        localStorage.removeItem('influencerCodeExpiration');
      }
    }
  }
};